import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ui-text-highlight',
  standalone: false,
  templateUrl: './highlight.component.html',
  styleUrls: ['./highlight.component.scss']
})
export class HighlightComponent implements OnInit {
  @Input() content : any;
  @Input() classList : any;
  constructor() { }

  ngOnInit(): void {
  }

}
